import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { formatMoney } from '../utils/utils.js'
require(`../assets/${process.env.PAGE}/css/product-option.css`);
import { ReactGA }  from './App';

class ProductOption extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
    }
        this.selectProduct = this.selectProduct.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { currentAmount, handleSubmitSelectedProduct } = this.props;
        if(currentAmount !== nextProps.currentAmount){
            handleSubmitSelectedProduct()
            this.setState({isActive:false})
        }
    }

    trackGAEvent() {
        let gaEvent = {}
        if(this.props.gaCategory) gaEvent.category = this.props.gaCategory;
        if(this.props.gaAction) gaEvent.action = this.props.gaAction;
        if(this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
        if(this.props.gaLabel) gaEvent.label = this.props.gaLabel;
        ReactGA.event(gaEvent);
    }

    selectProduct() {
        this.setState({isActive:true})
        this.props.onClick(this.props.quotaOption.toString(), this.props.amountQuotaOption);
        this.trackGAEvent()
    }

    render() {
        const { quotaOption, amountQuotaOption, isDiscount } = this.props;

        const { isActive } = this.state;

        const quotaOptionFormatted = quotaOption.toString()
        const amountQuotaOptionFormatted = formatMoney(amountQuotaOption, 0, ',', '.')

        const buttonClasses = `btn pd-choise-button ${isActive ? 'active' : ''}`;

        return (
            <div className="product-option">
                <Button
                    className={buttonClasses}
                    onClick={this.selectProduct}
                    disabled={ isDiscount ? true : false }>
                    <span className="quotas">{`${quotaOptionFormatted} cuotas fijas`}</span>
                    <span className="amount">de {amountQuotaOptionFormatted}</span>
                </Button>
            </div>
        );
    }
}


export default ProductOption;


/** WEBPACK FOOTER **
 ** ./src/components/ProductOption.js
 **/